<template>
    <div class="block-embed-content">
        <Component v-bind:is="component" />
    </div>
</template>

<script>
// Keep these imports since they are used in dynamically generated child component
import EmbedContentItem from '@/components/embed/EmbedContentItem.vue';
import VBtn from "@/components/button/VBtn.vue";

export default {
    name: 'BlockEmbedContent',
    data () {
        return {
            hasBeenMounted: false,
        };
    },
    props: {
        excludeFirstEmbed: {
            required: false,
            type: Boolean,
            default: false,
        },
        embeds: {
            required: true,
            type: Array,
        },
        contentBlocks: {
            required: true,
            type: Array,
        }
    },
    methods: {
        template () {
            const generateHtmlFromContentBlocks = () => {
                let html = '';
                if (this.contentBlocks.length === 0) return '<div></div>';
                if (this.contentBlocks.length === 1) return `<div>${this.contentBlocks[0]}</div>`;
                for (let i = 0; i < this.contentBlocks.length; ++i) {
                    html = html + this.contentBlocks[i];
                    if (this.embeds[i]) {
                        if (this.excludeFirstEmbed && i === 0) continue;
                        html = html + `<embed-content-item :content-item="embeds[${i}]"></embed-content-item>`;
                    }
                }
                html = `<div>${html}</div>`;
                return html;
            };
            let html = generateHtmlFromContentBlocks();
            html = this.$htmlUtilities.replaceButtonTags(html);
            if (this.hasBeenMounted) return this.$routerUtilities.replaceLinksWithNuxtRoutes(html);
            return html;
        },
    },
    mounted () {
        this.hasBeenMounted = true;
    },
    computed: {
        component () {
            // Nested component object
            return {
                template: this.template(),
                components: {
                    EmbedContentItem,
                    VBtn,
                },
                computed: {
                    embeds: () => {
                        return this.embeds; // Note that by using arrow function 'this' references the parent component
                    }
                }
            };
        },
    },
};
</script>
